var canUseDOM = function () {
    return !!(typeof window !== 'undefined' && window.document && (window.env ? window.env.NODE_ENV !== 'test' : true));
};
export default canUseDOM;
